export default __webpack_public_path__ + "static/media/tiktok.789650a2.svg";